var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"active":"dashboard"}}),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Hey, "+_vm._s(_vm.user.username))]),_c('div',{staticClass:"box"},[_vm._v("There's nothing here :)")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }